import React from "react";
import styled from "styled-components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Markup } from "interweave";
import { FullGrid } from "../../../assets/svgs";

const OurTeamCards = ({
  teamMembers,
  setSelectedTeamMember,
  setShowTeamMemberBio,
}) => {
  const colors = ["#645FE6", "#1AE299", "#FF7D50", "#36CBFF"];
  return (
    <Container>
      <SVGContainer>
        <FullGrid />
      </SVGContainer>
      <SVGContainer left>
        <FullGrid />
      </SVGContainer>
      <Title>Leadership Team</Title>
      <Cards>
        <HighlightedTeamMembers>
          {teamMembers.slice(0, 2).map((member, index) => (
            <Card
              key={member.id}
              color={colors[index]}
              onClick={() => {
                setSelectedTeamMember(member);
                setShowTeamMemberBio(true);
              }}
            >
              <Image
                image={getImage(member.image)}
                alt={member.title}
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
              <h3>
                <Markup content={`${member.name},<br /> ${member.title}`} />
              </h3>
              <button
                type="button"
                onClick={() => {
                  setSelectedTeamMember(member);
                  setShowTeamMemberBio(true);
                }}
              >
                View Bio
              </button>
            </Card>
          ))}
        </HighlightedTeamMembers>
        <Title style={{ marginTop: "2rem" }}>Clinical Team</Title>
        <OtherTeamMembers>
          {teamMembers.slice(2).map((member, index) => (
            <Card
              key={member.id}
              color={colors[index]}
              onClick={() => {
                setSelectedTeamMember(member);
                setShowTeamMemberBio(true);
              }}
            >
              <Image
                image={getImage(member.image)}
                alt={member.title}
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
              <h3>
                <Markup content={`${member.name},<br /> ${member.title}`} />
              </h3>
              <button
                type="button"
                onClick={() => {
                  setSelectedTeamMember(member);
                  setShowTeamMemberBio(true);
                }}
              >
                View Bio
              </button>
            </Card>
          ))}
        </OtherTeamMembers>
      </Cards>
    </Container>
  );
};

const Container = styled.section`
  grid-column: 1 / 7;
  padding: 3rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  position: relative;
  @media screen and (min-width: 1024px) {
    grid-column: 2 / 12;
    padding: 4rem 0;
  }
  @media screen and (min-width: 1600px) {
    grid-column: 3 / 11;
  }
`;

const Title = styled.h2`
  align-self: flex-start;
  color: var(--genseq-purple);
  font-size: 1.875rem;
  font-weight: 400;
  margin-bottom: 1.5rem;
  @media screen and (min-width: 1024px) {
    font-size: 2.25rem;
  }
`;

const Cards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 2;
`;

const HighlightedTeamMembers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media (min-width: 768px) {
    flex-direction: row;
  }
  @media (min-width: 1400px) {
    display: grid;
    grid-template-columns: repeat(3, 300px);
    gap: 4rem;
    justify-content: center;
    width: 100%;
    margin-bottom: 3rem;
  }
`;

const OtherTeamMembers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media (min-width: 768px) {
    flex-direction: row;
  }
  @media (min-width: 1400px) {
    display: grid;
    grid-template-columns: repeat(4, 300px);
    gap: 2rem;
    justify-content: center;
    width: 100%;
  }
`;

const Card = styled.div`
  display: grid;
  grid-template-rows: auto auto auto;
  gap: 1rem;
  width: 300px;
  height: 100%;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  margin: 0 auto;
  h3 {
    margin: 0;
    padding: 0 !important;
  }

  button {
    color: ${({ color }) => color};
    text-decoration: underline;
    font-size: 1rem;
    font-weight: 700;
    text-align: left;
    text-transform: uppercase;
    cursor: pointer;
  }

  &:hover {
    transform: scale(1.025) translateY(-3px);
  }
  @media (min-width: 768px) {
    grid-template-rows: auto 1fr auto;
  }
`;

const Image = styled(GatsbyImage)`
  width: 100%;
  height: auto;
  box-shadow: 0px 12px 30px rgba(217, 217, 217, 0.7);
  border-radius: 4px;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

const SVGContainer = styled.div`
  position: absolute;
  top: ${({ left }) => (left ? "unset" : "10%")};
  left: ${({ left }) => (left ? "-300px" : "unset")};
  bottom: ${({ left }) => (left ? "30%" : "unset")};
  right: ${({ left }) => (left ? "unset" : "-300px")};
  width: 800px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    height: 100%;
    width: auto;
  }
  z-index: 1;
`;

export default OurTeamCards;
